'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetCookieUser } = useUserService();
  const { data: user, isLoading } = useGetCookieUser();
  const isAuthenticated = Boolean(user);
  return { isAuthenticated, user, isLoading };
};
